module.exports = __webpack_public_path__ + "media/images/flags/es-1e69e4b92c945be4ed87955c04cd9053.svg";